var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4705 1.40424H0.529297V18.3454H17.4705V1.40424Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19925 2.3923C4.33256 2.21456 4.54178 2.10995 4.76395 2.10995H13.2346C13.4567 2.10995 13.6659 2.21456 13.7992 2.3923L15.9169 5.21583C16.0086 5.33802 16.058 5.48663 16.058 5.63936V15.5217C16.058 16.0833 15.8349 16.622 15.4379 17.0191C15.0407 17.4163 14.5021 17.6394 13.9404 17.6394H4.05808C3.49643 17.6394 2.95781 17.4163 2.56067 17.0191C2.16353 16.622 1.94043 16.0833 1.94043 15.5217V5.63936C1.94043 5.48663 1.98996 5.33802 2.0816 5.21583L4.19925 2.3923ZM5.1169 3.52172L3.35219 5.87465V15.5217C3.35219 15.7089 3.42656 15.8885 3.55894 16.0209C3.69132 16.1532 3.87087 16.2276 4.05808 16.2276H13.9404C14.1277 16.2276 14.3072 16.1532 14.4395 16.0209C14.572 15.8885 14.6463 15.7089 14.6463 15.5217V5.87465L12.8816 3.52172H5.1169Z",
    fill: "#292D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94043 5.63972C1.94043 5.24988 2.25646 4.93384 2.64631 4.93384H15.3522C15.7421 4.93384 16.058 5.24988 16.058 5.63972C16.058 6.02957 15.7421 6.3456 15.3522 6.3456H2.64631C2.25646 6.3456 1.94043 6.02957 1.94043 5.63972Z",
    fill: "#292D33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17659 7.75717C6.56644 7.75717 6.88248 8.07321 6.88248 8.46306C6.88248 9.02469 7.10558 9.56332 7.50271 9.96046C7.89985 10.3576 8.43848 10.5807 9.00012 10.5807C9.56175 10.5807 10.1004 10.3576 10.4975 9.96046C10.8947 9.56332 11.1177 9.02469 11.1177 8.46306C11.1177 8.07321 11.4338 7.75717 11.8237 7.75717C12.2135 7.75717 12.5296 8.07321 12.5296 8.46306C12.5296 9.39912 12.1577 10.2968 11.4957 10.9587C10.8339 11.6206 9.93618 11.9925 9.00012 11.9925C8.06406 11.9925 7.16634 11.6206 6.50444 10.9587C5.84255 10.2968 5.4707 9.39912 5.4707 8.46306C5.4707 8.07321 5.78674 7.75717 6.17659 7.75717Z",
    fill: "#292D33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.e5bf48b6753517e6bd2d5a1e690bb3d0.svg";
export { ForwardRef as ReactComponent };